<template lang="pug">
shListData(title="Imágenes" resolver="images" keyData="image" component="shImage")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'Images',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/image/Images.vue